import * as globalTypes from '@/store/mutation-types.js'
import icons from '@/mixins/icons.js'
import basicOperations from '@/mixins/basic-operations.js'

export default {
  name: 'MainMenu',
  mixins: [icons, basicOperations],
  computed: {
    mainMenuItems () {
      return this.$store.state.mainMenuItems.filter(function (item) {
        return !item.isStudentForParent
      })
    },
    studentsForParent () {
      return this.$store.state.mainMenuItems.filter(function (item) {
        return item.isStudentForParent
      })
    },
    isOuder () {
      return this.$store.state.userInfo.isOuder
    },
    showMenu () {
      return this.$store.state.flags.showMenu
    },
    username () {
      return this.$store.state.userInfo.loggedInConnectionObject ? this.$store.state.userInfo.loggedInConnectionObject.username : ''
    }
  },
  data () {
    return {
      currentPath: '/'
    }
  },
  watch: {
    // call again the method if the route changes
    $route: 'fetchData'
  },
  // mounted(){
  //   $('body').addClass('stop-scrolling')
  //   $('body').bind('touchmove', function(e){e.preventDefault()})
  //   $('body').unbind('touchmove')
  // },
  methods: {
    fetchData () {
      this.currentPath = this.$router.history.current.path
    },
  
    isCurrentPath (path) {
      try {
        return this.currentPath === path // .split('/')[1]
      } catch (e) {
        return false
      }
    },
    isStudentSelected (student) {
      return student.ID === this.$store.state.oudersSpecific.selectedKid.ID
    },
    clickedOnHome () {
      this.$store.commit(globalTypes.SET_LOGIN_REDIRECTED, false);
      this.arrangeModuleFlags('Landing Page')
      this.toggle()
      this._goTo('landing-page')
    },
    clickedOnInfo () {
      this.arrangeModuleFlags('Info')
      this.toggle()
      this._goTo('info')
    },
    arrangeModuleFlags (moduleName) {
      this.$store.commit(globalTypes.MODULE_CHANGING_USING_MAIN_MENU, true)
      this.$store.commit(globalTypes.SET_ACTIVE_MODULE, moduleName)
    },
    redirectFunctie (item, event) {
      this.arrangeModuleFlags(item.name)
      this.$router.push(item.path)
      if (typeof item.cbFunction !== 'undefined') {
        item.cbFunction()
      }
    },
    toggle () {
      this.$store.commit(globalTypes.TOGGLE_MENU)
      $('body').removeClass('stop-scrolling')
    },
    logout () {
      this.$store.dispatch('logout')
    }
  }
}
